import { mockOfficeAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockComplete, makeStreamEnd } from '../sseEvents';
const RESPONSE_ID = 'resp-defl-sup';
const CONV_ID = 'conv-1';
const DEFL_BLOCK_ID = 'blk-defl-sup';
const deflectionBlock = {
    type: 'deflection',
    block_id: DEFL_BLOCK_ID,
    block_index: 0,
    message: "I can't help with billing questions, but our support team can assist you.",
    category: 'billing',
    examples: ['How many inspections were completed last month?', 'Show me overdue buildings'],
    support_url: 'https://support.inspectpoint.com/billing',
    support_label: 'Contact Billing Support'
};
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockOfficeAgent),
    makeBlockComplete(deflectionBlock, 200),
    makeStreamEnd(RESPONSE_ID, 1, mockOfficeAgent)
];
export const scenario = {
    name: 'Deflection — With Support Link',
    description: 'Deflection response with a support URL and label, plus alternative examples.',
    conversations: mockConversations,
    userMessage: 'How do I update my payment method?',
    agentIdentity: mockOfficeAgent,
    sseSequence
};
